<template>
  <div class="customer-service-float" @click="goServicePage">💬</div>
</template>

<script>
export default {
  name: "CustomerServiceFloat",
  methods: {
    goServicePage() {
      if (this.$route.path === "/customerservice") {
        return;
      }
      this.$router.push("/customerservice");
    },
  },
};
</script>

<style scoped>
.customer-service-float {
  position: fixed;
  right: 20px;
  bottom: 100px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  z-index: 9999;
}
</style>
